var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import Checkbox from '@material-ui/core/Checkbox';
import { filter, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { FormControlLabel } from '@material-ui/core';
var DynamicCheckbox = /** @class */ (function (_super) {
    __extends(DynamicCheckbox, _super);
    function DynamicCheckbox(props) {
        var _this = _super.call(this, props) || this;
        _this._until = new Subject();
        _this.state = {
            value: null,
            invalid: null,
            help: null
        };
        return _this;
    }
    DynamicCheckbox.prototype.componentDidMount = function () {
        var _this = this;
        this.refreshValue();
        this.props.dataState.pathChange
            .pipe(takeUntil(this._until), filter(function (event) { return event.sender != _this && event.path == _this.props.control.path; }))
            .subscribe(function () { return _this.refreshValue(); });
        this.props.dataState.validationReset
            .subscribe(function () { return _this.setState({
            invalid: false,
            help: null
        }); });
        this.props.dataState.validationError
            .pipe(filter(function (event) { return event.path == _this.props.control.path; }))
            .subscribe(function (error) { return _this.setState({
            invalid: true,
            help: Object.keys(error.constraints)
                .map(function (key) { return React.createElement(React.Fragment, null,
                React.createElement("span", null, error.constraints[key]),
                React.createElement("br", null)); })
        }); });
    };
    DynamicCheckbox.prototype.componentWillUnmount = function () {
        this._until.next();
        this._until.complete();
    };
    DynamicCheckbox.prototype.setValue = function (value) {
        this.setState({
            value: value
        });
        this.props.dataState.set(this.props.control.path, value, {
            sender: this
        });
    };
    DynamicCheckbox.prototype.refreshValue = function () {
        this.setState({
            value: this.props.dataState.get(this.props.control.path)
        });
    };
    DynamicCheckbox.prototype.render = function () {
        var _this = this;
        return React.createElement(FormControlLabel, { label: this.props.control.label, control: React.createElement(Checkbox, __assign({}, this.props.options, { value: this.state.value || false, onChange: function (event) { return _this.setValue(event.target.value); } })) });
    };
    return DynamicCheckbox;
}(React.Component));
export default DynamicCheckbox;
//# sourceMappingURL=Checkbox.js.map